import React from 'react';

const Card = ({ title, children }) => {
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md dark:shadow-lg border border-gray-200 dark:border-gray-700 h-full flex flex-col transition-colors duration-300">
      {title && (
        <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
          {title}
        </h3>
      )}
      <div className="flex-grow">
        {children}
      </div>
    </div>
  );
};

export default Card;